// extracted by mini-css-extract-plugin
export default {"menu":"jKXuq_xRY1eg3KvuwwDX","item":"o0Kq7rs3EwpGxN4xVaEH","arrow":"R6CeOV4pRTu4Jkn9T_1o","text":"MUif87Cgbc4wHw7_xyfy","selected":"W8qLczhtQonLNPponl1F"};